import { createShell } from '../../shell/createShell';
import { route as loginAndSecurityRoute } from './pages/loginAndSecurity/loginAndSecurityPage';
import { route as paymentMethodsRoute } from './pages/paymentMethods/paymentMethodsPage';
import { route as resetPasswordRoute } from './pages/resetPassword/resetPasswordPage';
import { route as tripListRoute } from './pages/tripList/tripListPage';
import { route as userAreaRoute } from './pages/userArea/userAreaPage';
import { route as userMembershipRoute } from './pages/userMembership/userMembershipPage';
import { route as vehicleRentalListRoute } from './pages/vehicleRentalList/vehicleRentalListPage';
import { ProfileFunnel } from './index';
const routes = [loginAndSecurityRoute, paymentMethodsRoute, resetPasswordRoute, tripListRoute, userAreaRoute, userMembershipRoute, vehicleRentalListRoute];
export const profileShell = createShell(ProfileFunnel, {
  options: {
    routes,
    namespace: 'profile_shell'
  }
});